// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:36:21

export default {
  "id": "bffs-luxury-loungewear",
  "slug": "bffs-luxury-loungewear",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a428e6eb3cca4302883eb3d436dd89f8-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a428e6eb3cca4302883eb3d436dd89f8/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "BFFs Luxury Loungewear",
      "description": "Get ready to style your way to comfort in the BFFs Luxury Loungewear game! Join the fun with Riri, Elsa, Polka, and Bonnie, each with a unique wardrobe. Choose from jersey cotton, knitted, velour, or silk sleepwear and accessories to create stylish sleepover outfits. Exercise your fashion skills and make every slumber party a plush, luxury affair. This game is perfect for budding fashionistas and dress-up game enthusiasts alike!",
      "instructions": "Use your mouse to play this game on a desktop, tap to play on mobile devices. ",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "bffs",
        "dressing",
        "fashion",
        "girls",
        "princess"
      ]
    },
    "zh-CN": {
      "title": "bffs 奢华休闲服",
      "description": "准备好以你的方式在BFFs奢华家居服游戏中寻找舒适！与Riri、Elsa、波尔卡和Bonnie一起加入乐趣，每位角色都有独特的服装。从棉质圆领衫、针织、绒面或丝绸睡衣和配饰中选择，打造时尚的睡衣派对造型。锻炼你的时尚技巧，让每一次睡衣派对都成为柔软奢华的体验。这款游戏非常适合初露头角的设计师和装扮游戏爱好者！",
      "instructions": "使用鼠标在桌面设备上玩游戏，在移动设备上轻触屏幕玩游戏。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "bffs",
        "装扮",
        "时尚",
        "女孩",
        "公主"
      ]
    },
    "zh-TW": {
      "title": "BFFs豪華休閒服裝",
      "description": "準備好以時尚的方式將舒適帶進BFFs豪華休閒服遊戲！與Riri、Elsa、波卡和Bonnie一起享受樂趣，他們每個人都擁有獨特的衣著。從棉質緞、針織、毛絨或絲質睡衣和配件中選擇，打造時尚的睡眠派對造型。鍛煉你的時尚技巧，讓每一次的睡覺派對都變得柔軟、豪華。這款遊戲對潛在的時尚達人以及愛好装扮遊戲的玩家來說都是完美的！",
      "instructions": "使用滑鼠在桌面上遊戲，在行動裝置上點擊以遊戲。",
      "genres": [
        "打扮"
      ],
      "tags": [
        "bffs（最佳死黨）",
        "dressing（打扮）",
        "fashion（時裝）",
        "girls（女孩）",
        "princess（公主）"
      ]
    },
    "zh-HK": {
      "title": "最佳夥伴奢華休閒服",
      "description": "準備好以你獨特的風格踏上舒適之旅在BFFs豪華休閒服遊戲中！與Riri、Elsa、波卡和Bonnie一起加入樂趣，他們各自擁有獨特的衣著。從棉質T恤、針織、絨布或絲質睡衣及配飾中選擇，打造時尚的睡眠派對裝束。鍛鍊你的時尚技巧，讓每一次睡眠派對都變得軟綿綿、豪華。這款遊戲完美適合潛在的時尚愛好者和愛好打扮遊戲的玩家！",
      "instructions": "使用滑鼠於桌上型電腦遊戲，於行動裝置上則點擊以遊玩。",
      "genres": [
        "扮裝"
      ],
      "tags": [
        "bffs",
        "打扮",
        "時裝",
        "女孩",
        "公主"
      ]
    },
    "ja": {
      "title": "親友のラグジュアリーロунウェア",
      "description": "BFFs Luxury Loungewearゲームで快適さをスタイルで演出しよう！Riri、Elsa、ポルカ、そしてボニーと一緒に楽しみましょう。それぞれがユニークなウォークウェアを着ています。ジャージコットン、ニット、フレンチベッドシーツ、シルクの寝具やアクセサリーから選んで、スタイリッシュなオーバーナイトセットを作成してください。ファッションスキルを鍛え、すべてのスリーピーパーティーを豪華で贅沢なものにしましょう。このゲームは、ファッションの芽を育てる人々や、ドレスアップゲームのファンに最適です！",
      "instructions": "デスクトップでプレイする場合はマウスを使用してください。モバイルデバイスでプレイする場合はタップしてください。",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "bffs（親友たち）",
        "ドレッシング",
        "ファッション",
        "ガールズ",
        "プリンセス"
      ]
    },
    "ko": {
      "title": "친구들 럭셔리 라운지웨어",
      "description": "BFFs 럭셔리 루니웨어 게임에서 편안함을 위한 스타일링을 준비하세요! Riri, Elsa, Polka, 그리고 Bonnie와 함께 즐거움에 참여하세요. 각자 독특한 위드로우드를 선택하세요. 제리 크로스 콘트롤, 와이드, 벨벳, 그리고 실리크로 슬리퍼와 액세서리를 선택하여 스타일리한 스리퍼아웃을 만들어보세요. 패션 실력을 훈련하고, 모든 잠자리 파티를 풍부하고 럭셔리한 행사로 만들어보세요. 이 게임은 패션에 관심이 있는 젊은이들과 드레스업 게임을 사랑하는 사람들에게도 최적입니다!",
      "instructions": "마우스로 데스크톱에서 게임을 플레이하세요. 모바일 장치에서는 탭하여 플레이하세요.",
      "genres": [
        "드레스업"
      ],
      "tags": [
        "bffs",
        "드레싱",
        "패션",
        "소녀",
        "공주"
      ]
    },
    "fr": {
      "title": "Meilleures Amies de la Mode Luxueuse de Lounge",
      "description": "Préparez-vous à créer votre propre style de confort avec le jeu BFFs Luxury Loungewear ! Rejoignez le plaisir avec Riri, Elsa, Polka et Bonnie, chacune avec une garde-robe unique. Choisissez entre des vêtements de nuit en coton jersey, tricoté, velours ou soie et accessoires pour créer des tenues de soirée d'amis stylées. Exercez vos compétences en mode et transformez chaque récréation en une soirée de sommeil douce et luxueuse. Ce jeu est parfait pour les fashionistas en herbe et les fans de jeux de déguisement !",
      "instructions": "Utilisez votre souris pour jouer à ce jeu sur un ordinateur de bureau, appuyez pour jouer sur les appareils mobiles.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "meilleures amies",
        "habillage",
        "mode",
        "filles",
        "princesse"
      ]
    }
  }
};
